module.exports = __webpack_public_path__ + "static/img/huanjing_title.62c8f1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/huanjing_title.png
// module id = C3Dg
// module chunks = 0